import { v4 as uuid } from 'uuid';
import validate from "./validate";
import collect from "./collect";
import { nameByKind } from "./nameByKind";

const setMeta = (type, node, index, all, parentNodes) => {
  node.id = node.id || uuid();

  node.meta = {
    type,
    firstChild: index === 0,
    lastChild: index === all.length - 1,
    parentNodes,
    selected: node.meta ? node.meta.selected : false,
    resizing: node.meta ? node.meta.resizing : false,
    target: node.meta ? node.meta.target : null,
    forbidForTable:
      parentNodes &&
      parentNodes.some(n => n.type === "ITEM" && n.kind === "table")
  };


  switch (type) {
    case "SECTION": {
      node.meta = {
        ...node.meta,
        name: i18n.t('column'),
        droppable: true,
        draggable: true,
        selectable: true,
        removable: true,
        favoritable: true
      };
      break;
    }
    case "COLUMN": {
      node.meta = {
        ...node.meta,
        name: "Column",
        droppable: true,
        draggable: false,
        selectable: false,
        removable: false,
        favoritable: false
      };
      break;
    }
    case "CELL": {
      if (typeof node.background === 'undefined') node.background = 'transparent';
      if (typeof node.background_repeat === 'undefined') node.background_repeat = 'repeat';
      if (typeof node.background_image === 'undefined') node.background_image = 'none';
      if (typeof node.background_position === 'undefined') node.background_position = 'center top';
      node.meta = {
        ...node.meta,
        name: i18n.t('table.cell'),
        droppable: true,
        draggable: false,
        selectable: true,
        removable: false,
        favoritable: false,
        prompt: false,
      };
      break;
    }
    case "ITEM": {
      switch (node.kind) {
        case "button":
        case "image":
        case "block":
        case "divider":
        case "map":
        case "social":
        case "table":
        case "video":
        case "spacer": {
          node.meta = {
            ...node.meta,
            name: nameByKind(node.kind),
            kind: node.kind,
            droppable: false,
            draggable: true,
            selectable: true,
            removable: true,
            favoritable: true,
            editable: false
          };
          break;
        }
        case "html": {
          node.meta = {
            ...node.meta,
            name: nameByKind(node.kind),
            kind: node.kind,
            droppable: false,
            draggable: true,
            selectable: true,
            removable: true,
            favoritable: true,
            editable: true,
            edited: false
          };
          break;
        }
        case "unsubscrible":
        case "organization": {
          node.meta = {
            ...node.meta,
            name: nameByKind(node.kind),
            kind: node.kind,
            droppable: true,
            draggable: true,
            selectable: true,
            removable: true,
            favoritable: true
          };
        }
      }
    }
  }
};

export default (sections, needCopy = true) => {
  const preparedSections = needCopy
    ? JSON.parse(JSON.stringify(sections))
    : sections;
  validate(preparedSections); //TODO validates return false? WHY 🤔
  collect(preparedSections, setMeta);
  return preparedSections;
};
